import { IDigitalCard } from './bucket';
import { ICampaignItem } from './campaigns';
import { IMappedMskuItem, IRequestOnDemandItem } from './inventories';
import { IGiftBudget, TMarketplaceRequestMap } from './marketplace';
import { ICommonAddress, ShippingOptionsEnum } from './shipping';

export interface ISendsV2Address {
  address1: string;
  address2?: string;
  city: string;
  state?: string;
  zip: string;
  country: string;
}

export interface ISendsV2Recipient {
  email: string;
  first_name: string;
  last_name: string;
  phone?: string;
  company_name?: string;
  address?: ISendsV2Address;
  crm_type: string;
  crm_record_id: string;
  crm_record_type: string;
  crm_opportunity_id: string;
  tax_number?: string;
}

export type TSendsV2Item = ICampaignItem | IRequestOnDemandItem | IMappedMskuItem;

export interface ISendsV2ShippingFields {
  is_delayed_shipping: boolean;
  is_receiver_address_fixed: boolean;
  is_office_dropship_enabled: boolean;
  shipping_option: ShippingOptionsEnum;
  org_address_ids: string[];
  receiver_fixed_address: ICommonAddress;
}

export interface ISendsV2Request extends Partial<ISendsV2ShippingFields> {
  pre_created_engagement_id: string;
  pick_campaign_ids: string[] | null;
  items: TSendsV2Item[] | null;
  /** Present only with marketplace context (picks or a budget) — explicit nulls inside it. */
  marketplace?: TMarketplaceRequestMap | null;
  gift_budget?: IGiftBudget | null;
  recipients: Record<string, ISendsV2Recipient>;
  title?: string;
  business_reason_id: string;
  internal_notes: string;
  note_message: string;
  experience_id: string;
  on_hold_until?: string;
  send_on_behalf_the_email?: string;
  disable_email_notifications: boolean;
  disable_recipient_email_notifications: boolean;
  disable_recipient_shipped_email: boolean;
  email_subject?: string;
  email_message?: string;
  email_template_id?: string;
  receiver_reminder_interval: string;
  claim_link_expiration?: string;
  disable_shipment_tracking: boolean;
}

export interface ISendsV2SingleResponse {
  order_id: string;
  engagement_uid: string;
  digital_gifts: IDigitalCard[];
  delayed_shipping_url: string;
}

export interface ISendsV2BulkResponse {
  user_task_uid: string;
}

export type TSendsV2Response = ISendsV2SingleResponse | ISendsV2BulkResponse;

export const isBulkResponse = (body: unknown): body is ISendsV2BulkResponse => {
  const userTaskUid = (body as ISendsV2BulkResponse)?.user_task_uid;

  return typeof userTaskUid === 'string' && userTaskUid.length > 0;
};
